module.exports = __webpack_public_path__ + "media/images/icons/twotone/security-scan-f0e784093b37fcb9e5613c6cc9b0f4d1.svg";